import { createLogger } from 'shared/services/logger';
import Vue from 'vue';
import Services from 'shared/services';
import { createId } from 'shared/util';
import { parseConfig } from 'viewer/core/instance/config/parse-config';

const logger = createLogger('Viewer:core:init', ['log', 'warn', 'error']);

/**
 * Adds instance._init() method. Called by the constructor. Extracted to simplify testing
 * @param WebViewer
 */
export function initMixin (WebViewer) {
  WebViewer.prototype._initPromise = null;
  WebViewer.prototype._init = function (options) {
    logger.log(`Starting WebViewer v${WebViewer.version} @ ${WebViewer.buildDate}`);

    this._initPromise = new Promise(async (resolve, reject) => {
      await installVueServices(options, Vue);

      this.id = createId();

      this.config = parseConfig(options);

      resolve();
    });
  };
}

let installVueServices = async (options, Vue) => {
  await Services.install(Vue, options);

  // Once we've initialized no need to do so ever again.
  installVueServices = () => {
  };
};



// WEBPACK FOOTER //
// ./src/viewer/core/instance/init.js